module.exports = __webpack_public_path__ + "static/media/lock_white.cf664978.svg";